import { InjectionKey } from "@lib/svelte-typed-context";

import FormManager from "./FormManager";

export const formManagerToken: InjectionKey<FormManager> =
    Symbol("formManager");
